import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 5a3 3 0 0 1 3 3v3h4a1 1 0 0 1 0 2h-4v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3h-4a1 1 0 0 1 0 -2h4v-3a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconLayoutAlignMiddleFilled = createReactComponent('filled', 'layout-align-middle-filled', 'LayoutAlignMiddleFilled', __iconNode);

export default IconLayoutAlignMiddleFilled;